<template>
    <div
        v-if="!page.loading && page.user != undefined"
        :class="[
            page.updating ? 'updating' : '',
            !page.adminOverride ? 'lg:px-14 px-0 desktop-large:px-4 lg:pt-10' : '-mx-4',
            page.user.page.filters ? 'lg:grid-cols-[0fr_12fr]' : 'lg:grid-cols-[3fr_9fr]'
        ]"
        class="mx-auto max-w-page w-full lg:pb-6 py-0 min-h-[calc(100vh-80px)] grid relative
        lg:transition-[grid-template-columns] lg:duration-500 lg:ease-in-out"
    >
        <div class='absolute inset-0 bg-white/60 z-20' v-if='page.updating' />

            <!-- :class="{
                'lg:max-w-[0px]': page.user.page.filters,
                'lg:col-span-3': !page.user.page.filters,
            }" -->

            <!-- :class="{
                'lg:col-span-0 lg:max-w-[0px] absolute left-[-400px] border-white': page.user.page.filters,
                'lg:col-span-3 col-span-12 border-grey-500 lg:pr-14': !page.user.page.filters,
            }" -->

        <div class="transition-all duration-500 ease-in-out lg:min-h-full overflow-hidden  border-grey-500"
            :class='{
                "border-r lg:pr-14": !page.user.page.filters,
                "border-white": page.user.page.filters
            }'
        >
            <slot name="left"></slot>

            <TableFilters
                v-if="page.user != undefined && showFilters"
                ref="filters"
                :contentAbove="$slots.left"
                :dataLength="data != null ? data.length : 2"
                :dataName="dataName"
                :page="page"
                :hasSearch="hasSearch"
                @update:filters="filtersUpdated"
                :filtersLabel='filtersLabel'
                class="lg:min-h-full"
            >
                <template #below-label v-if='!!$slots["below-label"]'>
                    <slot name="below-label"></slot>
                </template>

                <template v-for="(_, name) in $slots" #[name]="slotProps">
                    <slot :name="name" v-bind="slotProps || {}"></slot>
                </template>
            </TableFilters>
        </div>

        <!-- {
            'lg:w-full': page.user.page.filters,
            'lg:w-[calc(100%-364px)]': !page.user.page.filters,
        } -->

        <!-- {
                'col-span-12': page.user.page.filters,
                'lg:col-span-9 lg:pl-14 col-span-12': !page.user.page.filters,
            } -->

        <div
            class="w-full px-4 pt-5 lg:pt-0 lg:px-0 transition-all duration-500 ease-in-out bg-white dark:bg-grey-2000 relative"
            :class="[tableCSS, {
                '': page.user.page.filters,
                'lg:pl-14': !page.user.page.filters
            }]"
        >
            <div class="flex justify-between items-center h-10 relative" id='table-header'>
                <button
                    :disabled="!page.user.page.filters"
                    class="flex items-center"
                    :class='{
                        "icon-hover": page.user.page.filters
                    }'
                    @click="filtersUpdated(!page.user.page.filters)"
                >
                    <div
                        :class="[page.user.page.filters ? 'w-10' : 'w-0']"
                        class="overflow-hidden transition-width duration-500 hidden lg:block"
                    >
                        <IconFilters class="h-6 w-6 shrink-0 mb-0.5" />
                    </div>
                    <h5 class="text-24 lg:text-28 font-bold font-hero">
                        <slot name="h5"></slot>
                    </h5>
                </button>

                <div class="flex items-center gap-6">
                    <!-- <div class='flex items-center' v-if='page.preUpdate || page.updating'>
                        <ClientOnly>
                            <Vue3Lottie :animationData="ZapoLogoJson" :height="24" :width="24" :loop="true" v-if="!loaded" />
                        </ClientOnly>

                        <p class='pl-2 text-grey-900'>Getting new data</p>
                    </div> -->

                    <slot name="options-left"></slot>
                    <TableOptions
                        :defaults="page.defaults"
                        :page="page"
                        :user="page.user"
                        @pageSave="get({ save: true })"
                        @reset="$refs.modalReset.show()"
                        :tableLabelChangeCheck="tableLabelChangeCheck"
                    >
                    </TableOptions>
                    <slot name="options-right"></slot>
                </div>
            </div>

            <!-- v-if='page.preUpdate || page.updating' -->
            <!-- <div class='!h-0 overflow-visable sticky z-20 top-0 transition-all'
                :class='[
                    windowTop > 200 && page.preUpdate == true || page.updating == true
                        ?  "opacity-100 delay-100" : "opacity-0 delay-[10ms]"
                ]'
            >
                <div class='w-full h-4 bg-white' />
                <div class='bg-black p-4 flex items-center'>
                    <div class='w-6 h-6'>
                        <ClientOnly>
                            <Vue3Lottie :animationData="ZapoLogoJson" :height="24" :width="24" :loop="true" />
                        </ClientOnly>
                    </div>

                    <p class='pl-2 text-white'>Getting new data {{ page.preUpdate }} {{  page.updating }} {{ windowTop }}</p>
                </div>
            </div> -->

            <slot name="above"></slot>
            <table
                v-if="showTable"
                :class="{
                    'multi-select': multiSelect,
                    'no-icon': multiSelectNoIcon,
                    selecting: selecting,
                }"
                class="table-page transition-all duration-500 ease-in-out transform-gpu"
            >
                <thead class="block w-full lg:table-header-group">
                    <tr :style="[gridColumns]" class="text-grey-900 text-14 block w-full relative !z-[2000]">
                        <th
                            class="!z-[2000]"
                            v-if="multiSelect || (!multiSelect && !multiSelectNoIcon)"
                            :class="[multiSelect ? 'col-span-2' : '']"
                        >
                            <template v-if="multiSelect">
                                <button
                                    v-if="!selecting"
                                    class="flex items-center icon-hover hover:text-grey-700"
                                    @click="selecting = true"
                                >
                                    <IconEdit class="h-5 w-5" />
                                    <p class="pl-2.5 lg:pl-5">
                                        {{ tableColumns[0] }}
                                    </p>
                                </button>
                                <div v-else class="flex items-end">
                                    <input
                                        class="input-checkbox"
                                        type="checkbox"
                                        :checked="data.length == page.selected.length"
                                        @click="multiSelectSelectAllFunction"
                                    />
                                    <DropdownV2
                                        :disabled="page.selected.length == 0"
                                        :ignoreParent="true"
                                        class="mt-px pl-2.5 lg:pl-5"
                                        forceSide="left"
                                        menuClass="mt-7 lg:mt-4 z-[2000]"
                                        @closed="$emit('multiSelectDropdownClosed')"
                                    >
                                        <template #button="{ open }">
                                            <div class="flex items-center">
                                                <p :class="{ 'text-grey-700': page.selected.length == 0 }" class="text-left">
                                                    {{ page.selected.length }} {{ $help.pluralize(dataName, page.selected.length) }} selected
                                                </p>
                                                <IconArrowDown
                                                    :class="{
                                                        'rotate-180': open,
                                                        'stroke-grey-800': page.selected.length == 0,
                                                        'stroke-black': page.selected.length > 0,
                                                    }"
                                                    class="h-4.5 w-4.5 transition-all ml-2"
                                                />
                                            </div>
                                        </template>
                                        <template #menu>
                                            <div
                                                v-if="page?.data?.data != null"
                                                class="table-multi-select-menu whitespace-nowrap min-w-[248px]"
                                            >
                                                <template v-if='page?.multiSelectOptionsVisible' v-for="action in page.call().multiSelectOptions()">
                                                    <button
                                                        v-if="action.enabled && action.action !== false"
                                                        v-bind:[action.subMenu]="true"
                                                        @click="action.action(action.selected)"
                                                        class='flex justify-between'
                                                    >
                                                        <p>{{ action.title  }}</p>
                                                        <IconArrowRight v-if="action.subMenu == 'data-ignore-click'" data-dont-close class="h-4.5 w-4.5 stroke-white" />
                                                    </button>

                                                    <div v-if="action.enabled && action.action === false"
                                                        class="px-4"
                                                        :class="[page.call().multiSelectOptions().filter((a) => a.enabled).length > 1 ? 'mt-4' : '']"
                                                    >
                                                        <div class="text-grey-800 pb-2 flex max-w-[220px]"
                                                            :class="[page.call().multiSelectOptions().filter((a) => a.enabled).length > 1 ? 'border-t border-white/20 pt-6' : 'pt-2']"
                                                        >
                                                            <IconInfo class="w-5 h-5 stroke-grey-700 shrink-0" />
                                                            <p class="pl-2 pt-px block !whitespace-break-spaces">{{ action.title }}</p>
                                                        </div>
                                                    </div>
                                                </template>

                                                <slot
                                                    :multiSelectOptions="page.call().multiSelectOptions()"
                                                    :selected="page.selected"
                                                    name="multimenu"
                                                />
                                            </div>
                                        </template>
                                    </DropdownV2>
                                    <button
                                        class="icon-hover shrink-0 h-4.5 w-4.5 ml-2"
                                        @click="
                                            () => {
                                                selecting = false
                                                page.selected = []
                                            }
                                        "
                                    >
                                        <IconClose class="h-4.5 w-4.5" />
                                    </button>
                                </div>
                            </template>
                        </th>
                        <template v-for="(th, thi) in tableColumns">
                            <template v-if='th !== null'>
                                <th
                                    v-if="!(multiSelect && parseInt(thi) == 0)"
                                    :class="[tableColumnsGrid != null && tableColumnsGrid[thi] != null ? tableColumnsGrid[thi] : '']"
                                >
                                    <p v-if="!selecting">{{ th }}</p>
                                </th>
                            </template>
                        </template>
                    </tr>
                </thead>
                <!-- , { 'z-index': 100 - tri } -->
                <tbody>
                    <slot name='trs' :gridColumns />
                    
                    <tr v-for="(tr, tri) in data" :key="tri" :style="[gridColumns, { transitionDelay: tri * 33 + 'ms' }]">
                        <td
                            v-if="multiSelect || !multiSelectNoIcon"
                            :class="[typeof selectedTd == 'object' ? selectedTd[tri] : selectedTd, selecting ? 'h-6 lg:h-auto' : '']"
                            class="p-0 relative w-fit lg:w-auto z-10"
                        >
                            <slot v-if="!selecting" :data="tr" :dataI="tri" name="default"></slot>
                            <input
                                v-if="selecting"
                                :checked="multiSelectIsRowSelectedFunction(tr)"
                                :value="tr.id"
                                class="input-checkbox mt-[3px] lg:mt-0"
                                name="selected[]"
                                type="checkbox"
                                @click="multiSelectRowClickFunction(tr)"
                            />
                        </td>
                        <slot
                            :data="tr"
                            :dataI="tri"
                            :labels="page.defaults.labels"
                            :selecting="selecting"
                            :tableColumnsGrid="tableColumnsGrid"
                            name="tr"
                        >
                        </slot>
                    </tr>
                </tbody>
            </table>

            <div v-if="page.data != null && showTable" class="block lg:flex justify-between items-center lg:flex-row flex-col pt-10 lg:pb-10 relative lg:mx-0 -mx-4 min-h-[158px] lg:min-h-0">
                <div class='flex items-center justify-center'>
                    <TablePagination :page="page" :pagination="page.data" />
                </div>

                <DropdownV2
                    class='block lg:hidden w-full'
                    :menuPush='true'
                    :scrollToBottomFirst='true'
                >
                    <template #button="{ open }">
                        <div class="flex items-center justify-center bg-white dark:bg-transparent dark:bg-black w-full py-4">
                            <p class="pr-2 text-14">
                                Showing {{ showing }} of {{ page.data.total }}
                                {{ $help.pluralize(dataName, page.data.total) }}
                            </p>
                            <IconArrowDown
                                :class="{
                                    'rotate-180': open,
                                }"
                                class="h-5 w-5 stroke-black transition-all"
                            />
                        </div>
                    </template>
                    <template #menu>
                        <div class="table-multi-select-menu bg-black min-w-[260px]">
                            <button
                                v-for="i in page.defaults.rows"
                                :class="{
                                    'text-grey-800': i == page.user.rows,
                                }"
                                :disabled="i == page.user.rows"
                                data-close
                                @click="setPage(i)"
                            >
                                Show {{ i }} {{ dataName }}s
                            </button>
                        </div>
                    </template>
                </DropdownV2>

                <DropdownV2
                    class='lg:block hidden lg:mt-0 mt-3'
                    v-if="page.defaults != null && page.defaults.rows != null"
                    :menuSpace="8"
                    forceSide="right"
                    menuClass="!overflow-hidden"
                    :scrollToBottomFirst="true"
                >
                    <template #button="{ open }">
                        <div class="flex items-center bg-white dark:bg-black dark:bg-black">
                            <p class="pr-2 text-14">
                                Showing {{ showing }} of {{ page.data.total }}
                                {{ $help.pluralize(dataName, page.data.total) }}
                            </p>
                            <IconArrowDown
                                :class="{
                                    'rotate-180': open,
                                }"
                                class="h-5 w-5 stroke-black transition-all"
                            />
                        </div>
                    </template>
                    <template #menu>
                        <div class="table-multi-select-menu bg-black min-w-[260px]">
                            <button
                                v-for="i in page.defaults.rows"
                                :class="{
                                    'text-grey-800': i == page.user.rows,
                                }"
                                :disabled="i == page.user.rows"
                                data-close
                                @click="setPage(i)"
                            >
                                Show {{ i }} {{ dataName }}s
                            </button>
                        </div>
                    </template>
                </DropdownV2>
            </div>
            <slot v-if="!showTable" name="page" />
            <slot :selected="page.selected" name="bottom" />
        </div>
    </div>
</template>

<!-- <transition-group appear
				name='tr-slide-right'
				tag='tbody'
			> -->
<!-- <tr v-for='i in 10' :key='i-20' v-if='table == null'>
				<slot name='loading'></slot>
			</tr> -->
<!-- { transitionDelay: (tri*50)+'ms' } -->

<script>
import TableFilters from '~/components/customer/table/table-filters.vue'
import TableOptions from '~/components/customer/table/table-options.vue'
import TablePagination from '~/components/customer/table/table-pagination.vue'
import ZapoLogoJson from '~/assets/animation-zapo-logo.json'

export default {
    data() {
        return {
            selecting: false,
            showUpdated: false,
            windowTop: 0,
            ZapoLogoJson
        }
    },
    created() {
        // console.log('page', {...this.page})
        this.$event.$on('multiSelectCompleted', (msg) => {
            this.multiSelectCompleted(msg)
        })
    },
    // mounted() {
    //     window.addEventListener("scroll", this.onScroll)
    // },
    // beforeDestroy() {
    //     window.removeEventListener("scroll", this.onScroll)
    // },
    methods: {
        onScroll(e) {
            this.windowTop = window.top.scrollY
        },
        setPage(p) {
            // console.log("setting page", p);
            // this.$event.$emit("page-rows", p)
            this.page.user.rows = p
            this.page.call().updated()
        },
        resetTable() {
            this.$event.$emit('page-reset')
            this.showResetTable = false
        },
        toggleSelected(id) {
            this.page.selected.indexOf(id) === -1
                ? this.page.selected.push(id)
                : this.page.selected.splice(this.page.selected.indexOf(id), 1)
        },
        multiSelectCompleted(message = false) {
            // this.$event.$emit('toast-new-message', {
            //     text: message,
            // })
            this.page.selected = []
            this.selecting = false
        },
        multiSelectIsRowSelectedFunction(row) {
            return this.multiSelectIsRowSelected(this, row)
        },
        multiSelectRowClickFunction(row) {
            return this.multiSelectRowClick(this, row)
        },
        multiSelectSelectAllFunction() {
            return this.multiSelectSelectAll(this)
        },
        filtersUpdated(f) {
            this.page.user.page.filters = f
            this.page.call().save()
        },
    },
    computed: {
        tableColumns() {
            if (this.page.loading) {
                return ['']
            }
            if (this.page.user != undefined && this.page.user.columns != undefined && Object.keys(this.page.defaults.columns).length > 0) {
                let cols = []
                let n = 0
                for (let i in this.page.user.columns) {
                    if (this.page.user.columns[i] == false) {
                        cols.push(null)
                        continue
                    }
                    let label =
                        this.page.defaults.columns[i] != undefined && this.page.defaults.columns[i].label != undefined
                            ? this.page.defaults.columns[i].label
                            : i
                    // console.log('label', label)
                    if (n == 0 && this.multiSelect) {
                        label = this.data.length == 1 ? label : this.$help.pluralize(label, this.data.length)

                        label =
                            (this.page.defaults.columns[i].multi_select_label !== undefined
                                ? this.page.defaults.columns[i].multi_select_label
                                : 'Edit') +
                            ' ' +
                            label
                    }
                    cols.push(this.$help.capitalizeFirstLetter(label.replace(/_/g, ' ')))
                    n++
                }
                return cols
            } else {
                return this.thead
            }
        },
        gridColumns() {
            if (this.page.loading) {
                return ''
            }
            let cols = this.gridOverride != null ? this.gridOverride : this.tableColumns.length
            // + (this.multiSelect ? 0 : 1);
            let gtc = 'grid-template-columns: '
            if (this.thead == null) {
                if ((this.multiSelect && !this.multiSelectNoIcon) || this.selecting) {
                    gtc += '40px '
                    cols++
                } else if (!this.multiSelect && this.multiSelectNoIcon) {
                    gtc += ''
                } else {
                    gtc += '0px '
                }
                let cnt = -1
                for (let i in this.page.user.columns) {
                    cnt++
                    if (this.page.user.columns[i] == false && this.page.defaults.columns[i]?.required !== true) {
                        continue
                    }
                    gtc += 'minmax(20px, ' + this.tableColumnsGrid[cnt] + ') '
                }
            } else if (this.thead != null && this.thead.length > 0) {
                for (let i in this.thead) {
                    gtc += 'minmax(20px, ' + this.tableColumnsGrid[i] + ') '
                    // cnt++;
                }
            }
            return gtc
        },
        showing() {
            return this.page.data.per_page > this.page.data.total ? this.page.data.total : this.page.data.per_page
        },
        data() {
            if (this.page.data != null) {
                return this.page.data.data
            }
            return null
        },
        emptyMaxHeight() {
            return window.innerHeight - 350
        },
    },
    components: {
        TableFilters: TableFilters,
        TableOptions: TableOptions,
        TablePagination: TablePagination,
    },
    props: {
        page: Object,
        thead: {
            type: Array,
            default: null,
        },
        gridOverride: {
            type: Number,
            default: null,
        },
        tableColumnsGrid: {
            type: Array,
            default: null,
        },
        multiSelect: false,
        multiSelectNoIcon: {
            type: Boolean,
            default: false,
        },
        showTable: {
            type: Boolean,
            default: true,
        },
        showFilters: {
            type: Boolean,
            default: true,
        },
        dataName: {
            type: String,
            default: 'data',
        },
        selectedTd: {
            type: [String, Object],
            default: 'align-top',
        },
        tableCSS: String,
        filtersLabel: { type: String, default: 'Filters' },
        multiSelectIsRowSelected: {
            type: Function,
            default: function (self, row) {
                return self.page.selected.indexOf(row.id) >= 0
            },
        },
        multiSelectRowClick: {
            type: Function,
            default: function (self, row) {
                self.page.selected.indexOf(row.id) === -1
                    ? self.page.selected.push(row.id)
                    : self.page.selected.splice(self.page.selected.indexOf(row.id), 1)
            },
        },
        multiSelectSelectAll: {
            type: Function,
            default: function (self) {
                // console.log({
                //     'self.page.selected.length': self.page.selected.length,
                //     'self.data.length': self.data.length,
                //     'self.page.selected': self.page.selected,
                // })
                self.page.selected.length == self.data.length
                    ? (self.page.selected = [])
                    : (self.page.selected = self.data.map((a) => a.id))
            },
        },
        tableLabelChangeCheck: {
            type: Function,
            default: function (labels, label, enabled) {},
        },
        hasSearch: { type: Boolean, default: true }
    },
}
</script>
